module.exports = __webpack_public_path__ + "static/media/02.35061f69.jpg";